.root {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacer-16);
    list-style: none;
    margin: 0;
    padding: 0;
}

.link {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background: var(--white);
    color: var(--black);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    transition:
        background-color 150ms ease,
        color 150ms ease;

    :global(.imageDataWrapper) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (hover: hover) {
        &:hover {
            background: var(--poppy);

            .icon {
                filter: brightness(0);
            }
        }
    }

    &:focus-visible,
    &[data-focus-visible],
    &[data-focus-visible="true"] {
        outline: 2px solid var(--poppy);
        outline-offset: 2px;
    }
}

.icon {
    width: 16px;
    height: 16px;
    display: block;
    object-fit: contain;
    transition: filter 150ms ease;
}
